import { Fragment } from 'react';
import type { LibraryCategory } from '../../api/centerstageApi';
import { CENTERSTAGE_COPY as COPY } from '../../components/centerstage/centerstageCopy';
import type { CenterstageStyles } from '../../components/centerstage/centerstageStyles';

export interface CenterstageCategoryRowProps {
  styles: CenterstageStyles;
  categories: readonly LibraryCategory[];
  selectedId: number | null;
  /** null selects "All" (no category filter). */
  onSelect: (categoryId: number | null) => void;
}

/** "All" plus the live categories; exactly one reads pressed. Scrolls sideways when it no longer fits. */
export function CenterstageCategoryRow({ styles, categories, selectedId, onSelect }: CenterstageCategoryRowProps) {
  const items: Array<{ id: number | null; name: string }> = [{ id: null, name: COPY.allCategories }, ...categories];
  return (
    <div role="group" aria-label={COPY.categoryRowLabel} style={styles.categoryRow}>
      {items.map((item, index) => {
        const selected = item.id === selectedId;
        return (
          <Fragment key={item.id ?? 'all'}>
            {index > 0 ? <span aria-hidden="true" style={styles.categorySeparator} /> : null}
            <button
              type="button"
              aria-pressed={selected}
              onClick={() => onSelect(item.id)}
              style={{ ...styles.categoryButton, ...(selected ? styles.categoryButtonSelected : {}) }}
            >
              {item.name}
            </button>
          </Fragment>
        );
      })}
    </div>
  );
}
